export default __webpack_public_path__ + "static/media/heiwa.90df3ecd.svg";